export const iconFontAwesomeHumanitarianTruckPlane = (
	<i className="fa-solid fa-truck-plane"></i>
);
